// extracted by mini-css-extract-plugin
module.exports = {"dots-container":"YQ_79YVb2JEVqxJil6nhI","dot":"_2ovNHc9xXxxD3IlQPk_j94","fulfilled":"_2Ss67GVIDtzP8rPbpKjskr"};